import { render, staticRenderFns } from "./PageContent.vue?vue&type=template&id=979fc2c0&"
import script from "./PageContent.vue?vue&type=script&lang=ts&"
export * from "./PageContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageComponentList: require('/builds/simistry/gm/graduatemastery.com-nuxt/site/components/PageComponentList.vue').default,PageImage: require('/builds/simistry/gm/graduatemastery.com-nuxt/site/components/PageImage.vue').default})
